module.exports = function getResource(label, vars = []) {
    let resources = {
        done: 'Done',
        clear: 'Clear'
    };
    return resources[label];
};
